module.exports = __webpack_public_path__ + "fonts/iconfont.4e53388c.ttf";